import {Directive, OnDestroy} from '@angular/core';
import {NgxEchartsDirective} from 'ngx-echarts';
import {Subscription} from 'rxjs';
import {appendItemCountsToAriaLabel} from './echarts-theme';

/**
 * Shares the selector of ngx-echarts, so it is attached to every `<div echarts>` of the module: it adds the
 * number of items of each series to the aria label of the chart (see appendItemCountsToAriaLabel).
 */
@Directive({
  selector: '[echarts]',
  standalone: false
})
export class EchartsItemCountDirective implements OnDestroy {
  private chartInitSubscription: Subscription;

  constructor(ngxEcharts: NgxEchartsDirective) {
    this.chartInitSubscription = ngxEcharts.chartInit.subscribe((chart) => appendItemCountsToAriaLabel(chart));
  }

  ngOnDestroy(): void {
    this.chartInitSubscription.unsubscribe();
  }
}
